import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  changeRoyalty(event) {
    const sizeFrame = event.target.closest("turbo-frame")

    sizeFrame.src = sizeFrame.src.split("?")[0] + "?royalty=" + event.target.value
    sizeFrame.reload()
  }
}
